import React from "react";
import logger from "logger";

import AccountDetailsSection from "TaskHistory/Tasklet/SubTasklets/AccountDetailsSection.js";
import StatusSection from "TaskHistory/Tasklet/SubTasklets/StatusSection.js";
import ErrorLogsSection from "TaskHistory/Tasklet/SubTasklets/ErrorLogsSection.js";
import ActionsSection from "TaskHistory/Tasklet/SubTasklets/ActionsSection.js";
import TaskletCard from "./TaskletCard";
import CardContent from "@material-ui/core/CardContent";
import { getCityGenericNameFromNumber } from "Utils/Common";
import { getRssNameFromCode } from "Utils/TaskService";
import { StringValue } from "./StringValue";
import { StringMap } from "./StringMap";

export default function(props) {
  const { task } = props;

  return (
    <TaskletCard title="Reassign Rss">
      <CardContent>
        <AccountDetailsSection
          task={task}
          showOwner={props.showOwner}
          showUser={props.showUser}
        />
        <StatusSection task={task} />
        <StringValue
          label={"Source City"}
          value={getCityGenericNameFromNumber(
            task.taskstatusdetail.sourceCityNumber
          )}
        />
        <StringValue
          label={"Target City Coords"}
          value={`${task.taskstatusdetail.destinationX},
          ${task.taskstatusdetail.destinationY}`}
        />
        <StringValue
          label={"Marches Done"}
          value={task.taskstatusdetail.marchesdone}
        />
        <StringMap
          label={"Rss Done"}
          valueMap={task.taskstatusdetail.rssdone}
          valueParser={(k, v) =>
            v > 0 ? `${getRssNameFromCode(k)}: ${v}` : null
          }
        />
        <StringMap
          label={"Rss Left"}
          valueMap={task.taskstatusdetail.rssleft}
          valueParser={(k, v) =>
            v > 0 ? `${getRssNameFromCode(k)}: ${v}` : null
          }
        />
        <ErrorLogsSection task={task} />
      </CardContent>
      <ActionsSection task={task} />
    </TaskletCard>
  );
}
